module.exports = __webpack_public_path__ + "static/media/details-24px.e18f7eb2.svg";